import { type SearchRequest } from '@searchkit/api';

import { createResponseFactory } from '~/search-domain/pipelines/match-centre/response-factory';
import { type MatchupCentreESResultBody } from '~/search-domain/pipelines/match-centre/types';
import { type SearchDomainContext } from '~/search-domain/types';
import { createElasticSearchContext, createResponseFactoryContext, isFacetOnlyRequest } from '~/search-domain/utils';

export async function transformMatchupCentreResponse(
  context: SearchDomainContext,
  { searchRequest, searchResponse }: { searchRequest: SearchRequest; searchResponse: MatchupCentreESResultBody },
) {
  const params = searchRequest?.request?.params;
  // No subevents aggregation was attached to a facet-only request, so there is nothing to reshape.
  if (isFacetOnlyRequest(searchRequest) || !params) {
    return searchResponse;
  }

  const hitsPerPage = params.hitsPerPage ?? 10;
  const page = params.page ?? 0;
  const from = page * hitsPerPage;

  const elasticContext = createElasticSearchContext(context);

  return createResponseFactory.call(
    createResponseFactoryContext(context),
    elasticContext,
    searchResponse,
    from,
    hitsPerPage,
  );
}
